<!--
 * @Description: 常规工作/日常事务 请假
 * @Author: 王赵坤
 * @Date: 2022-12-28 15:57:15
 * @LastEditors: PF
 * @LastEditTime: 2023-08-08 18:19:07
-->
<template>
  <div>
    <el-dialog class="w1000 h700" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">学生考勤</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
      <el-container>
        <el-header>
          <!-- 搜索区域 BEGIN -->
          <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>

            <el-form-item>
              <el-select v-model="dataGrid.parms.xqid" placeholder="学期" @change='bindTable()' class="filter-item" filterable>
                <el-option v-for="(item) in xqData" :key="item.id" :label="item.xqmc" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="dataGrid.parms.zyid" placeholder="专业" clearable @change='bindTable()' class="filter-item" filterable>
                <el-option v-for="(item) in zhuanyelisu" :key="item.id" :label="item.zymc" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="dataGrid.parms.njid" placeholder="所在年级" clearable @change='bindTable()' class="filter-item" filterable>
                <el-option v-for="(item) in nianjilist" :key="item.id" :label="item.njmc" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="dataGrid.parms.bjid" placeholder="所在班级" clearable @change='bindTable()' class="filter-item" filterable>
                <el-option v-for="(item) in banjilist" :key="item.id" :label="item.xzbmc" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-form>
          <!-- 搜索区域 END -->
        </el-header>
        <el-main>
          <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
            <el-table-column type="index" label="序号" align="center" width="80" sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column prop="xsxm" label="学生姓名" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column prop="xsxh" label="学号" align="center" show-overflow-tooltipsortable :sort-orders="['ascending', 'descending']" />
            <el-table-column fixed="right" label="请假次数" align="center" width="280">
              <template #default="scope">
                <span>{{scope.row.qjcs}}次</span>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="旷课次数" align="center">
              <template #default="scope">
                <span>{{scope.row.kkcs}}次</span>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="早退次数" align="center">
              <template #default="scope">
                <span>{{scope.row.ztcs}}次</span>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="迟到次数" align="center">
              <template #default="scope">
                <span>{{scope.row.cdcs}}次</span>
              </template>
            </el-table-column>
          </el-table>
        </el-main>
        <el-footer>
          <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
        </el-footer>
      </el-container>
    </div>
    </el-dialog>
    <!-- 办理 弹窗 结束 -->
  </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import { loadList, homeCloseWindow, loadSelect } from '@/api/common.js'
import pagination from '@/components/pagination.vue'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

// 内容区域 开始
const xqData = ref() // 学期
const banjilist = ref() // 班级数据
const xqid = ref() // 学期
// 获取学期数据
const getxqlist = () => {
  loadSelect({
    url: '/api/v2/pdp/xueqi/list',
    data: xqData,
    order: 'sx',
    sort: 'asc',
    loadSuccess: function (res) {
      res.data.forEach((element) => {
        if (element.sfdqxq === true) {
          xqid.value = element.id
          dataGrid.value.parms.xqid = element.id
          bindTable()
        }
      })
    }
  })
}
const nianjilist = ref()
// 年纪
const getnianji = () => {
  loadSelect({
    url: '/api/v2/pdp/nianji/list',
    data: nianjilist,
    order: 'njdm',
    sort: 'asc'
  })
}
const zhuanyelisu = ref()
// 专业
const getzhuanye = () => {
  loadSelect({
    url: '/api/v2/pdp/zhuanye/list',
    data: zhuanyelisu,
    order: 'zydm',
    sort: 'asc'
  })
}
// 班级
const getbanji = () => {
  loadSelect({
    url: '/api/v2/pdp/banji/banzhuren',
    data: banjilist,
    parms: { xqid: xqid.value },
    order: 'xzbdm',
    sort: 'asc'
  })
}
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'xsxh', order: 'ascending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/jiaowu/xueshengkaoqin/xueshengkaoqin',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function (res) {
      dataGrid.value.multipleSelection = []
    }
  })
}

const openList = ref(false)

watch(
  () => props.open,
  () => {
    if (props.open === 'xueshengkaoqin') {
      openList.value = true
      getxqlist()
      getnianji()
      getzhuanye()
      getbanji()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
</script>
